import React from 'react';
import styled, { useTheme } from 'styled-components';
import ReactModal from 'react-modal';
import { FlexColumn } from '@make-software/cspr-design';

import { CloseButtonSection } from './close-button-section';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const ModalContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: ['300px', '400px', '446px'],
    background: theme.styleguideColors.backgroundPrimary,
    borderColor: theme.styleguideColors.backgroundPrimary,
    overflowY: ['scroll', 'unset', 'unset'],
    // height: ['500px', 'unset']
  })
);

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const theme = useTheme();

  const modalStyles: ReactModal.Styles = {
    overlay: {
      backgroundColor: theme.styleguideColors.backgroundOverlay,
      zIndex: 15
    },
    content: {
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      borderRadius: 'none',
      padding: '32px 24px 24px 24px',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      paddingTop: '20px',
      border: 'none',
      backgroundColor: theme.styleguideColors.backgroundPrimary,
      borderTop: `4px solid ${theme.styleguideColors.contentRed}`,
      borderColor: theme.styleguideColors.contentRed,
      boxShadow: '0px 16px 48px rgba(26, 25, 25, 0.2)'
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyles}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick>
      <ModalContainer>
        <CloseButtonSection onClose={onClose} marginBottom="0" />
        {children}
      </ModalContainer>
    </ReactModal>
  );
};
